/* eslint-disable */
import React, { useState } from "react";
import { Button, Card, Typography, Box, Radio, RadioGroup, FormControlLabel, useTheme, Grid, Container, CircularProgress, Tooltip } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useLocation, useNavigate } from "react-router";
import { useMutation } from "@apollo/client";
import EditIcon from "../../Images/edit-icon.svg";
import { getTextMetrics } from "../../utils/myUtills";
import AiGeneratePopup from "../Modal/AiGeneratePopup";
import { handleHeadingGenerate, handleParagraphGenerate, highlightKeyword, navigateToBlog } from "../../utils/blogUtils";
import StepProgress from "./StepProgress";
import { GENERATE_HEADING, GENERATE_PARAGRAPH } from "../../gql/mutations/keyword";
import { usePopup } from "../../context/commonPop";
import { SectionWrapper } from "./AiBlogWriter";

function BlogParagraphs() {
  const location = useLocation();
  const navigate = useNavigate();
  const { title, paragraphs, formsState, activeSteps } = location.state || {};
  const theme = useTheme();
  const { handleOpen } = usePopup();
  const [open, setOpen] = useState(false);
  const [paragraph, setParagraph] = useState(paragraphs);
  const [heading, setHeading] = useState([]);
  const [activeStep, setActiveStep] = useState(activeSteps);
  const [generateParagraph] = useMutation(GENERATE_PARAGRAPH);
  const [generateHeading] = useMutation(GENERATE_HEADING);
  const [selectedParagraph, setSelectedParagraph] = useState("");
  const [formState, setFormState] = useState({
    keyword: formsState?.keyword,
    selectedTitle: formsState?.selectedTitle,
    selectedParagraph: formsState?.selectedParagraph,
    language: formsState?.language || "English",
    count: formsState?.count,
    loading: formsState?.loading,
    isCheckedParagraph: formsState?.isCheckedParagraph,
  });
  const [writeMoreParagraphLoading, setWriteMoreParagraphLoading] = useState(false);
  const [regenerateAllLoading, setregeneratAllLoading] = useState(false);
  const [generateHeadingLoading, setGenerateHeadingLoading] = useState(false);
  const handleOpens = paragraph => {
    setSelectedParagraph(paragraph);
    setOpen(true);
  };
  const handleRadioChange = e => {
    const { name, value } = e.target;
    setFormState(prev => ({ ...prev, [name]: value, isCheckedParagraph: false }));
  };

  const handleParagraphUpdate = updatedIntroduction => {
    const { word_count, character_count } = getTextMetrics(updatedIntroduction);
    setParagraph(prevParagraph => prevParagraph.map(item => (item.Introduction === selectedParagraph ? { Introduction: updatedIntroduction, word_count, character_count } : item)));
    setOpen(false);
  };

  const handleGoBack = (formState, setFormState, navigateToBlog, navigate, title) => {
    if (formState.selectedParagraph !== "") {
      setFormState(prevState => {
        const updatedState = {
          ...prevState,
          selectedParagraph: "",
        };

        navigateToBlog("title", title, updatedState, navigate);
        return updatedState;
      });
    } else {
      navigateToBlog("title", title, formState, navigate);
    }
  };
  return (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Card sx={{ padding: "18px 14px 18px 14px", border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important", overflow: "visible" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={{ position: "sticky", left: "0", top: { xs: "42px", sm: "47px", lg: "53px" }, zIndex: 999999 }}>
                <StepProgress activeStep={activeStep} formState={formState} />
              </Grid>
              <Grid item xs={12}>
                <Box className="IntroParagraph">
                  <Card sx={{ padding: "20px 14px 14px 14px", border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important" }}>
                    <Typography className="representsHeading" component="h2">
                      Choose an intro paragraph that describes your content.
                    </Typography>
                    <RadioGroup name="selectedParagraph" value={formState.selectedParagraph} onChange={handleRadioChange}>
                      {paragraph?.map((item, index) => (
                        <Box className="representContentBox" key={index + 1}>
                          <Box className="InnerContent">
                            <FormControlLabel
                              value={item.Introduction}
                              control={<Radio className="radioBtn" />}
                              className="radioGroupBox"
                              label={
                                <Box>
                                  <Typography component="h3">{highlightKeyword(item.Introduction, formState.keyword)}</Typography>
                                  <Typography variant="body2">
                                    {item.word_count} words / {item.character_count} characters
                                  </Typography>
                                </Box>
                              }
                            />
                          </Box>
                          <Button className="editBtn" onClick={() => handleOpens(item.Introduction)} disabled={formState.loading}>
                            <Typography component="img" src={EditIcon} alt="" />
                          </Button>
                        </Box>
                      ))}
                    </RadioGroup>

                    <Box className="BtnGroup">
                      <Tooltip
                        title={`Click to generate ${formsState?.count} more titles based on your selection.`}
                        placement="top"
                        PopperProps={{
                          sx: {
                            "& .MuiTooltip-tooltip": {
                              mb: "10px !important",
                              textAlign: "center",
                            },
                          },
                        }}
                      >
                        <Button
                          className="moreTitle"
                          disabled={writeMoreParagraphLoading || regenerateAllLoading || generateHeadingLoading}
                          onClick={async e => {
                            setWriteMoreParagraphLoading(true);
                            await handleParagraphGenerate({
                              e,
                              isRegenerate: false,
                              formState,
                              setFormState,
                              generateParagraph,
                              paragraph,
                              titles: title,
                              setParagraph,
                              setActiveStep,
                              handleOpen,
                              navigate,
                              type: "paragraph",
                            });
                            setWriteMoreParagraphLoading(false);
                          }}
                        >
                          {writeMoreParagraphLoading ? (
                            <CircularProgress size={20} />
                          ) : (
                            <>
                              <AutoAwesomeIcon /> Write More Paragraph
                            </>
                          )}
                        </Button>
                      </Tooltip>
                      <Button
                        className="moreTitle"
                        disabled={writeMoreParagraphLoading || regenerateAllLoading || generateHeadingLoading}
                        onClick={async e => {
                          setregeneratAllLoading(true);
                          await handleParagraphGenerate({
                            e,
                            isRegenerate: true,
                            formState,
                            setFormState,
                            generateParagraph,
                            paragraph,
                            titles: title,
                            setParagraph,
                            setActiveStep,
                            handleOpen,
                            navigate,
                            type: "paragraph",
                          });
                          setregeneratAllLoading(false);
                        }}
                      >
                        {regenerateAllLoading ? (
                          <CircularProgress size={20} />
                        ) : (
                          <>
                            <RefreshIcon /> Re-Generate All
                          </>
                        )}
                      </Button>
                    </Box>
                    <Box className="BottomBtnGroup">
                      <Button
                        className="BackBtn"
                        onClick={() => {
                          handleGoBack(formState, setFormState, navigateToBlog, navigate, title);
                        }}
                        disabled={formState.loading}
                      >
                        Go Back
                      </Button>

                      <Button
                        className="generateIntro"
                        onClick={async e => {
                          setGenerateHeadingLoading(true);
                          await handleHeadingGenerate({
                            e,
                            isRegenerate: false,
                            formState,
                            setFormState,
                            generateHeading,
                            setActiveStep,
                            handleOpen,
                            navigate,
                            type: "heading",
                            heading,
                            setHeading,
                            paragraph,
                            title: title,
                          });
                          setGenerateHeadingLoading(false);
                        }}
                        disabled={formState.isCheckedParagraph || writeMoreParagraphLoading || regenerateAllLoading || generateHeadingLoading}
                      >
                        {generateHeadingLoading ? <CircularProgress size={20} /> : "Generate Heading"}
                      </Button>
                    </Box>
                  </Card>
                  <AiGeneratePopup open={open} setOpen={setOpen} titleText={selectedParagraph} setTitleText={handleParagraphUpdate} />
                </Box>
              </Grid>
            </Grid>
          </Card>
        </Box>
      </Container>
    </SectionWrapper>
  );
}

export default BlogParagraphs;
